import React from "react";

// COMPONENTS
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import RowReportTemplate from "./rowReportTemplate/rowReportTemplate";

// UTILS/API
import { getTranslateByKey } from "@/main/services/utils";
import { ReportTemplateGridResponse } from "@/main/models/response";
import { ReportTemplateFilterRequest } from "@/main/models/request";
import { reportTemplateApi } from "@/main/api";

import * as S from "./styles";

interface IGridReportTemplateProps {
	dataGrid: ReportTemplateGridResponse[];
	formFilters: ReportTemplateFilterRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<any[]>>;
}

function GridSearchReportTemplate({ dataGrid, formFilters, setDataGrid }: IGridReportTemplateProps) {
	const rowHeaders = [
		getTranslateByKey("information.companyType"),
		getTranslateByKey("control.company"),
		getTranslateByKey("information.reportTemplateName"),
		getTranslateByKey("information.lastUpdate"),
		getTranslateByKey("information.status"),
		getTranslateByKey("information.actions"),
	];

	async function fetchData(request: any) {
		return reportTemplateApi.getReportTemplateGrid(request).then((response) => response.data);
	}

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchData}
			>
				<BoxGrid rowHeaders={rowHeaders}>
					{dataGrid.map((item, index) => (
						<RowReportTemplate reportTemplate={item} index={index} key={item.guid} />
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridSearchReportTemplate;
